require('./bootstrap');


$(function () {
    if ($('#reservation-date-picker')) {
        $('#reservation-date-picker').datepicker({
            minDate: new Date(),
            autoClose: true
        });
    }
    if ($('#reservation-time-picker')) {
        $('#reservation-time-picker').datepicker({
            timepicker: true,
            onlyTimepicker: true,
            timeFormat: 'hh:ii AA',
            minutesStep: 5
        });
    }

    $('.date-picker').datepicker({
        minDate: new Date(),
        autoClose: true,
        language: 'en'
    });

    $('.time-picker').datepicker({
        timepicker: true,
        onlyTimepicker: true,
        timeFormat: 'hh:ii AA',
        minutesStep: 5,
        language: 'en'
    });
});


$(function () {
    $('[data-toggle="tooltip"]').tooltip({
        container: 'body',
    });
})
$(function () {
    // Leamington reservation popup
    $('#bookingModalLeamington').on('show.bs.modal', function (e) {
        $("#bookingModalLeamington .modal-body").html("<div id='quandoo-booking-widget'></div><script src='https://booking-widget.quandoo.com/index.js' data-merchant-id='95354'data-theme='light'data-primary-color='07004d'></script>");
    });
    $('#bookingModalLeamington').on('hide.bs.modal', function (e) {
        $("#bookingModalLeamington .modal-body").html("");
    });

    // Leicester reservation popup
    $('#bookingModalLeicester').on('show.bs.modal', function (e) {
        $("#bookingModalLeicester .modal-body").html("<div id='quandoo-booking-widget'></div><script src='https://booking-widget.quandoo.com/index.js' data-merchant-id='95355'data-theme='light'data-primary-color='07004d'></script>");
    });
    $('#bookingModalLeicester').on('hide.bs.modal', function (e) {
        $("#bookingModalLeicester .modal-body").html("");
    });

    // Nottingham reservation popup
    $('#bookingModalNottingham').on('show.bs.modal', function (e) {
        $("#bookingModalNottingham .modal-body").html("<div id='quandoo-booking-widget'></div><script src='https://booking-widget.quandoo.com/index.js' data-merchant-id='95357'data-theme='light'data-primary-color='07004d'></script>");
    });
    $('#bookingModalNottingham').on('hide.bs.modal', function (e) {
        $("#bookingModalNottingham .modal-body").html("");
    });
});